// Meta Pixel helper

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

const PIXEL_ID = '849651377704810'

export const CHECKOUT_URL = 'https://www.upreferr.com/cart/44596916224135:1'

// Use this on the onClick of an <a target="_blank"> CTA so the browser
// natively opens the new tab AND we still fire the AddToCart pixel.
export function handleCheckoutClick(): void {
  trackAddToCart()
}

function loadFbq(): boolean {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return false
  }
  if (window.fbq) return true

  try {
    const f: any = window
    const b: any = document
    const e = 'script'
    const v = 'https://connect.facebook.net/en_US/fbevents.js'

    const n: any = function () {
      // eslint-disable-next-line prefer-rest-params
      n.callMethod
        ? // eslint-disable-next-line prefer-rest-params
          n.callMethod.apply(n, arguments)
        : // eslint-disable-next-line prefer-rest-params
          n.queue.push(arguments)
    }
    f.fbq = n
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t: any = b.createElement(e)
    t.async = true
    t.src = v

    const firstScript: any = b.getElementsByTagName(e)[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(t, firstScript)
    } else {
      const target = b.head || b.body || b.documentElement
      if (target) target.appendChild(t)
    }

    return true
  } catch (err) {
    console.warn('[MetaPixel] init failed:', err)
    return false
  }
}

export function initMetaPixel(): void {
  if (!loadFbq()) return
  try {
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  } catch (err) {
    console.warn('[MetaPixel] PageView failed:', err)
  }
}

export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}): void {
  if (typeof window === 'undefined') return
  if (!window.fbq) {
    // Lazy-init in case the user clicks before the effect ran (e.g. SSR / nav prefetch quirks).
    if (!loadFbq()) return
    try {
      window.fbq('init', PIXEL_ID)
    } catch {
      /* ignore */
    }
  }
  try {
    window.fbq('track', 'AddToCart', {
      value: params?.value ?? 8.49,
      currency: params?.currency ?? 'USD',
      content_name: params?.content_name ?? 'Código Hormonal 40+',
      content_ids: ['codigo-hormonal-40'],
      content_type: 'product',
    })
  } catch (err) {
    console.warn('[MetaPixel] AddToCart failed:', err)
  }
}
